import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { toast } from "react-toastify";
import { IoMdSearch } from "react-icons/io";
import { MdDeleteSweep } from "react-icons/md";
import DeleteButton from "../../components/ul/DeleteButton";
import generateCaptcha from "../../components/captcha";
import NotFound from "../../components/ul/NotFound";
import formatDateTime from "../../components/formatDateTime";
import { LuDot } from "react-icons/lu";
import {
  FaArrowLeft,
  FaArrowRight,
  FaEye,
  FaTrash,
  FaCheck,
} from "react-icons/fa";
import ActionButton from "../../components/ul/ActionButton";
import img1 from "../../Image/Profile.png";
import MainButton from "../../components/ul/MainButton";
import { Link, useNavigate } from "react-router-dom";
import getISTDate from "../../components/getISTDate";
import toIST from "../../components/toIST";

// Modal component to show user details
const WithdrawModal = ({ open, data, onClose }) => {
  if (!open || !data) return null;
  const {
    u_info,
    u_Name,
    u_type,
    u_wcoin,
    total_coin,
    u_Amount,
    status,
    u_Bank_Name,
    u_Bank_AHN,
    u_Bank_IFSC,
    u_Bank_AC,
    u_Upi,
    createdAt,
    u_binance,
    u_email,
  } = data;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-40">
      <div className="bg-white p-8 rounded-xl shadow-2xl relative min-w-[340px] max-w-[95vw] w-full md:max-w-md">
        <button
          className="absolute top-2 right-2 text-gray-500 text-xl hover:text-red-600"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        <h2 className="text-xl font-bold mb-4">Withdraw Details</h2>
        <div className="flex flex-col items-center gap-3 mb-4">
          <img
            src={u_info?.u_profile || img1}
            alt="Profile"
            className="w-16 h-16 rounded-full object-cover mb-2"
          />
          <span className="text-base font-semibold">{u_Name || "N/A"}</span>
          <span className="text-sm text-gray-600">
            {u_info?.u_email || "-"}
          </span>
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-2 mb-2">
          <div>
            <span className="text-xs text-gray-500">Type</span>
            <div className="text-sm font-semibold">{u_type || "N/A"}</div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Amount</span>
            <div className="text-sm font-semibold">₹{u_Amount || "0"}</div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Coin</span>
            <div className="text-sm">{u_wcoin || "0"}</div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Total Coin</span>
            <div className="text-sm">{total_coin || "0"}</div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Status</span>
            <div
              className={`text-sm font-semibold flex items-center ${
                status ? "text-green-600" : "text-red-600"
              }`}
            >
              <LuDot size={18} /> {status ? "Success" : "Pending"}
            </div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Date</span>
            <div className="text-sm">{formatDateTime(createdAt)}</div>
          </div>
        </div>
        {u_type === "Bank" && (
          <div className="mt-3 space-y-1 text-sm">
            <div>
              <span className="text-xs text-gray-500">Bank Name: </span>
              {u_Bank_Name || "-"}
            </div>
            <div>
              <span className="text-xs text-gray-500">Account Holder: </span>
              {u_Bank_AHN || "-"}
            </div>
            <div>
              <span className="text-xs text-gray-500">IFSC: </span>
              {u_Bank_IFSC || "-"}
            </div>
            <div>
              <span className="text-xs text-gray-500">Account No: </span>
              {u_Bank_AC || "-"}
            </div>
          </div>
        )}
        {u_type === "Upi" && (
          <div className="mt-3 text-sm">
            <span className="text-xs text-gray-500">UPI: </span> {u_Upi || "-"}
          </div>
        )}
        {u_type === "Binance" && (
          <div className="mt-3 text-sm">
            <span className="text-xs text-gray-500">Binance : </span>{" "}
            {u_binance || "-"}
          </div>
        )}
        {u_type === "Paypal" && (
          <div className="mt-3 text-sm">
            <span className="text-xs text-gray-500">Paypal Email: </span>{" "}
            {u_email || "-"}
          </div>
        )}
      </div>
    </div>
  );
};

const Withdraw = () => {
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(getISTDate());
  const [endDate, setEndDate] = useState(getISTDate());
  const [search, setSearch] = useState("");
  const limit = 1000;
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalWithdraw, setTotalWithdraw] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [selectState, setSelectState] = useState("today");
  const [statusFilter, setStatusFilter] = useState("pending");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const navigate = useNavigate();
  // Fetch data
  const fetchData = async () => {
    setLoader(true);
    try {
      const response = await Calling.GetUserWithdraw(
        currentPage,
        startDate,
        endDate,
        limit,
        search,
        false,
        statusFilter === "all"
          ? ""
          : statusFilter === "success"
          ? "true"
          : "false"
      );
      if (response?.status) {
        setData(response?.data);
        setTotalPages(response?.totalPage);
        setTotalWithdraw(response?.totalRecord);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [currentPage, startDate, endDate, statusFilter]);

  useEffect(() => {
    if (search.trim() !== "") {
      const delayDebounce = setTimeout(() => {
        fetchData();
      }, 500);
      return () => clearTimeout(delayDebounce);
    }
  }, [search]);

  const handleSearch = (e) => {
    setCurrentPage(1);
    setSearch(e.target.value);
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      const allUserIds = data.map((user) => user._id);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
    setSelectAll(!selectAll);
  };

  const handleDeleteSelected = async (id) => {
    const content = `You are about to delete a user. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (check) {
      try {
        setLoader(true);
        let body = {};
        if (id) {
          body.id = [id];
        } else {
          body.id = selectedUsers;
        }
        const response = await Calling.DeleteUserWithdraw(body);
        if (response?.status) {
          toast.success(response?.message);
          setSelectedUsers([]);
          setSelectAll(false);
          fetchData();
        } else {
          toast.error(response?.message);
        }
      } catch (error) {
        console.error("Error deleting users:", error);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Captcha answer is incorrect", { autoClose: 2000 });
    }
  };

  const handleAcceptSelected = async (id) => {
    const content = `You are about to accept selected withdrawal(s). To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (check) {
      try {
        setLoader(true);
        let body = {};
        if (id) {
          body.id = [id];
        } else {
          body.id = selectedUsers;
        }
        const response = await Calling.UserWithdrawAccept(body);
        if (response?.status) {
          toast.success(response?.message);
          setSelectedUsers([]);
          setSelectAll(false);
          fetchData();
        } else {
          toast.error(response?.message);
        }
      } catch (error) {
        console.error("Error accepting users:", error);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Captcha answer is incorrect", { autoClose: 2000 });
    }
  };

  const handleSelectUser = (id) => {
    if (selectedUsers.includes(id)) {
      setSelectedUsers(selectedUsers.filter((userId) => userId !== id));
    } else {
      setSelectedUsers([...selectedUsers, id]);
    }
  };

  const handleDateRangeFilter = (range) => {
    const today = new Date();
    let start, end;

    switch (range) {
      case "today":
        start = end = toIST(today);
        setSelectState("today");
        break;

      case "yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        start = end = toIST(yesterday);
        setSelectState("yesterday");
        break;

      case "thisWeek":
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - today.getDay());
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
        start = toIST(firstDayOfWeek);
        end = toIST(lastDayOfWeek);
        setSelectState("thisWeek");
        break;

      case "thisMonth":
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        start = toIST(monthStart);
        end = toIST(monthEnd);
        setSelectState("thisMonth");
        break;

      case "last6Months":
        const sixMonthStart = new Date(
          today.getFullYear(),
          today.getMonth() - 5,
          1
        );
        const sixMonthEnd = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        start = toIST(sixMonthStart);
        end = toIST(sixMonthEnd);
        setSelectState("last6Months");
        break;

      case "thisYear":
        const yearStart = new Date(today.getFullYear(), 0, 1);
        const yearEnd = new Date(today.getFullYear(), 11, 31);
        start = toIST(yearStart);
        end = toIST(yearEnd);
        setSelectState("thisYear");
        break;

      default:
        start = end = "";
    }

    setStartDate(start);
    setEndDate(end);
    setCurrentPage(1);
  };

  const handleFormDate = (e) => {
    if (e.target.name === "startDate") {
      setStartDate(e.target.value);
    } else {
      setEndDate(e.target.value);
    }
  };

  const handleView = (user) => {
    setModalData(user);
    setModalOpen(true);
  };

  const handleEdit = (id) => navigate(`/manage/user/all/info/${id}`);

  return (
    <>
      <div className="w-full md:ml-[4.4rem] px-3 sm:px-4 lg:px-6 mt-16">
        <div className="bg-white rounded-xl shadow-sm mt-4 overflow-hidden">
          <h1 className="text-xl sm:text-2xl font-bold px-4 py-3 text-gray-800">
            Withdraw Management
          </h1>

          <hr className="border-gray-200" />

          {/* Date Range Filters */}
          <div className="flex flex-col lg:flex-row lg:justify-between gap-3 p-3 sm:p-4">
            {/* Mobile Dropdown */}
            <div className="lg:hidden mb-4">
              <select
                onChange={(e) => handleDateRangeFilter(e.target.value)}
                className="w-full border border-main-border px-4 py-2 rounded-xl focus:ring-2 focus:ring-main-blue focus:outline-none"
              >
                <option value="">Select Filter</option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="thisWeek">This Week</option>
                <option value="thisMonth">This Month</option>
                <option value="last6Months">Last 6 Months</option>
                <option value="thisYear">This Year</option>
                <option value="range">Custom Range</option>
              </select>
            </div>

            {/* Desktop Buttons */}
            <div className="hidden lg:flex flex-wrap gap-2 mb-4">
              <MainButton
                onClick={() => handleDateRangeFilter("today")}
                label="Today"
                selectState={selectState === "today"}
              />
              <MainButton
                onClick={() => handleDateRangeFilter("yesterday")}
                label="Yesterday"
                selectState={selectState === "yesterday"}
              />
              <MainButton
                onClick={() => handleDateRangeFilter("thisWeek")}
                label="This Week"
                selectState={selectState === "thisWeek"}
              />
              <MainButton
                onClick={() => handleDateRangeFilter("thisMonth")}
                label="This Month"
                selectState={selectState === "thisMonth"}
              />
              <MainButton
                onClick={() => handleDateRangeFilter("last6Months")}
                label="Last 6 Months"
                selectState={selectState === "last6Months"}
              />
              <MainButton
                onClick={() => handleDateRangeFilter("thisYear")}
                label="This Year"
                selectState={selectState === "thisYear"}
              />
            </div>

            {/* Date Range Inputs */}
            <div className="hidden md:flex gap-2">
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={handleFormDate}
                className={`border px-4 py-2 rounded-lg w-full sm:w-auto ${
                  selectState === "range" ? "border-blue-600 text-blue-600" : ""
                }`}
              />
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={handleFormDate}
                className={`border px-4 py-2 rounded-lg w-full sm:w-auto ${
                  selectState === "range" ? "border-blue-600 text-blue-600" : ""
                }`}
              />
            </div>
          </div>

          <hr className="border-gray-100 mx-2 sm:mx-4" />

          <div className="p-4 bg-main-th mb-4 md:my-4 rounded-xl mx-2 sm:mx-4">
            <h2 className="text-base sm:text-lg text-gray-600">
              Total Withdraw
            </h2>
            <p className="text-xl font-semibold text-gray-800">
              {totalWithdraw < 10 ? "0" + totalWithdraw : totalWithdraw}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-4 mx-2 sm:mx-4">
            {/* Filter */}
            <select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
              className="border border-gray-300 bg-white px-4 py-2 rounded-lg focus:ring-2 focus:ring-main-blue outline-none"
            >
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="success">Success</option>
            </select>

            {/* Buttons */}
            {selectedUsers.length > 0 && (
              <div className="flex gap-2">
                <button
                  onClick={() => handleAcceptSelected(null)}
                  className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-all duration-200"
                >
                  <FaCheck className="text-white" />
                  Accept
                </button>

                <button
                  onClick={() => handleDeleteSelected(null)}
                  className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-all duration-200"
                >
                  <MdDeleteSweep className="text-white" />
                  Delete
                </button>
              </div>
            )}

            {/* Search at end ALWAYS */}
            <div className="relative w-full sm:w-64 ml-auto">
              <IoMdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
              <input
                type="search"
                value={search}
                onChange={handleSearch}
                placeholder="Search"
                className="w-full px-4 py-2 pl-10 border rounded-full focus:ring-2 focus:ring-main-blue outline-none"
              />
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto rounded-xl shadow-sm border border-gray-200 mt-4">
            <table className="min-w-full border-separate border-spacing-y-2 text-left">
              <thead className="sticky top-0 bg-main-th text-gray-800 text-xs uppercase">
                <tr>
                  <th className="p-3">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th className="p-3">#</th>
                  <th className="p-3">Profile</th>
                  <th className="p-3">Name</th>
                  <th className="p-3">Type</th>
                  <th className="p-3">Coin</th>
                  <th className="p-3">Total Coin</th>
                  <th className="p-3">Amount</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">Date</th>
                  <th className="p-3 text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                {loader ? (
                  Array.from({ length: 6 }).map((_, i) => (
                    <tr
                      key={i}
                      className="animate-pulse border-b transition-all"
                    >
                      <td className="p-3">
                        <div className="w-4 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-6 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-10 h-10 bg-gray-200 rounded-full" />
                      </td>
                      <td className="p-3">
                        <div className="w-24 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-16 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-14 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-14 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-14 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="w-20 h-6 bg-gray-200 rounded-full" />
                      </td>
                      <td className="p-3">
                        <div className="w-20 h-4 bg-gray-200 rounded-sm" />
                      </td>
                      <td className="p-3">
                        <div className="flex gap-3 justify-center">
                          <div className="w-5 h-5 bg-gray-200 rounded-sm" />
                          <div className="w-5 h-5 bg-gray-200 rounded-sm" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : data.length > 0 ? (
                  data.map((user, index) => (
                    <tr
                      key={user._id}
                      className="hover:bg-main-thHover border-b transition-all"
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          checked={selectedUsers.includes(user._id)}
                          onChange={() => handleSelectUser(user._id)}
                        />
                      </td>

                      <td className="p-3">
                        {index + 1 + (currentPage - 1) * limit}
                      </td>

                      <td
                        className="p-3 cursor-pointer"
                        onClick={() => handleEdit(user?.u_info?._id)}
                      >
                        <img
                          src={user?.u_info?.u_profile || img1}
                          alt="profile"
                          className="w-10 h-10 rounded-full object-cover cursor-pointer"
                        />
                      </td>

                      <td
                        className="p-3 font-medium cursor-pointer"
                        onClick={() => handleEdit(user?.u_info?._id)}
                      >
                        {user.u_Name || "N/A"}
                      </td>
                      <td className="p-3">{user.u_type}</td>
                      <td className="p-3 font-semibold">{user.u_wcoin}</td>
                      <td className="p-3 font-semibold">{user.total_coin}</td>

                      <td className="p-3">
                        {user.u_amount_type === "rs" ? "₹" : "$"}{" "}
                        {user.u_Amount}
                      </td>

                      <td className="p-3">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 ${
                            user.status
                              ? "bg-green-100 text-green-600"
                              : "bg-orange-100 text-orange-600"
                          }`}
                        >
                          <LuDot size={18} />
                          {user.status ? "Success" : "Pending"}
                        </span>
                      </td>

                      <td className="p-3">{formatDateTime(user.createdAt)}</td>

                      <td className="p-3 flex gap-3 justify-center">
                        <button
                          onClick={() => handleView(user)}
                          className="text-blue-600 hover:text-blue-800"
                          title="View"
                        >
                          <FaEye size={18} />
                        </button>
                        <button
                          onClick={() => handleDeleteSelected(user._id)}
                          className="text-red-600 hover:text-red-800"
                          title="Delete"
                        >
                          <FaTrash size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={11} className="text-center p-6">
                      <NotFound />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {data.length > 0 && (
            <div className="flex flex-col sm:flex-row justify-between items-center my-6 gap-4 bg-gray-50 rounded-xl px-5 py-4 border border-gray-200">
              {/* Left Navigation Buttons */}
              <div className="flex items-center gap-3">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className={`px-5 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2 transition-all ${
                    currentPage === 1
                      ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                      : "bg-main-blue text-white hover:bg-blue-700 shadow"
                  }`}
                >
                  <FaArrowLeft size={14} /> Previous
                </button>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`px-5 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2 transition-all ${
                    currentPage === totalPages
                      ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                      : "bg-main-blue text-white hover:bg-blue-700 shadow"
                  }`}
                >
                  Next <FaArrowRight size={14} />
                </button>
              </div>

              {/* Page Number Indicator */}
              <div className="flex items-center gap-2 text-gray-700">
                <span className="px-4 py-2 bg-white border border-gray-300 rounded-xl shadow-sm font-semibold min-w-[45px] text-center">
                  {currentPage < 10 ? `0${currentPage}` : currentPage}
                </span>
                <span className="text-sm font-medium">/</span>
                <span className="px-4 py-2 bg-white border border-gray-300 rounded-xl shadow-sm font-semibold min-w-[45px] text-center">
                  {totalPages < 10 ? `0${totalPages}` : totalPages}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Modal for viewing withdraw details */}
        <WithdrawModal
          open={modalOpen}
          data={modalData}
          onClose={() => setModalOpen(false)}
        />
      </div>
    </>
  );
};
export default Withdraw;
